import { render, staticRenderFns } from "./purprice.vue?vue&type=template&id=6736144e&scoped=true&"
import script from "./purprice.vue?vue&type=script&lang=js&"
export * from "./purprice.vue?vue&type=script&lang=js&"
import style0 from "./purprice.vue?vue&type=style&index=0&id=6736144e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6736144e",
  null
  
)

export default component.exports